<template>
    <v-app-bar v-if="user" elevation="0" color="white" max-height="70">
      <v-toolbar-title class="mt-3">
        <img src="../assests/bellavista.jpeg" alt="" width="160">
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu
        offset-y
        open-on-hover
        bottom
      >
       <template v-slot:activator="{ on, attrs }">
         <v-btn
           v-bind="attrs"
           v-on="on"
           fab
           small
           color="indigo"
           class="white--text text-body-1"
          >
             {{ user.name.split(" ")[0] [0]}}
          </v-btn>
        </template>
        <v-card width="220">
          <v-list dense>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">
                 {{ user.name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                {{ user.email }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item to="/profile">
              <v-list-item-icon>
                <v-icon color="indigo">mdi-account</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="indigo--text" to="/profile">
                Profile
              </v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="logout">
              <v-list-item-icon>
                <v-icon color="error">mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="error--text"  @click="logout">
                Logout
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
      <!-- <v-btn :loading="loading" text @click="logout" color="#4E5FBB"> <v-icon left>mdi-logout</v-icon> Logout </v-btn> -->
    </v-app-bar>
</template>

<script>
import { headersAuth, logout } from '../links.js'
export default {
  name: 'App Bar',
  data () {
    return {
      loading: false,
      user: null
    }
  },
  methods: {
    logout  () {
      this.loading = true
      const token = localStorage.getItem('BVtoken')
      const header = { headers: headersAuth(token) }

      this.$http.post(logout, {}, header)
        .then(response => {
          if (response.data.message === 'Successfully logged out') {
            this.$store.commit('showFeedback', { text: response.data.message, color: 'success' })
            this.$store.commit('setUserId', null)
            this.$store.commit('setUser', null)
            localStorage.removeItem('BVtoken')
            this.$store.commit('setUserData', null)
            this.$router.push('/login')
          } else {
            this.$store.commit('showFeedback', { text: response.data.message, color: 'error' })
          }
        })
        .catch(err => {
          console.error(err)
          this.$store.commit('showFeedback', { text: 'Something went wrong', color: 'error' })
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  created () {
    this.user = this.$store.state.user
    console.log('user in app bar', this.user.id)
  }
}
</script>
